/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * お客さま情報
 */
export interface Sgkb575aResVisitInfo {
    /** 
     * お客さま区分：半角英数混在
     */
    visitDiv?: string;
    /** 
     * お客さま区分名称：全角半角混在
     */
    visitDivAname?: string;
    /** 
     * お客さま漢字氏名：全角文字
     */
    visitName?: string;
    /** 
     * お客さまカナ氏名：全角カナ
     */
    visitKanaName?: string;
    /** 
     * お客さま電話番号コード１：半角英数混在
     */
    visitTeldv1?: string;
    /** 
     * お客さま電話番号コード１名称：全角半角混在
     */
    visitTeldv1Aname?: string;
    /** 
     * お客さま電話番号１：電話番号(ハイフンと数値含む)
     */
    visitTelNo1?: string;
    /** 
     * お客さま電話番号コード２：半角英数混在
     */
    visitTeldv2?: string;
    /** 
     * お客さま電話番号コード２名称：全角半角混在
     */
    visitTeldv2Aname?: string;
    /** 
     * お客さま電話番号２：電話番号(ハイフンと数値含む)
     */
    visitTelNo2?: string;
    /** 
     * お客さま電話番号コード３：半角英数混在
     */
    visitTeldv3?: string;
    /** 
     * お客さま電話番号コード３名称：全角半角混在
     */
    visitTeldv3Aname?: string;
    /** 
     * お客さま電話番号３：電話番号(ハイフンと数値含む)
     */
    visitTelNo3?: string;
    /** 
     * 外部連携ID：半角英数混在
     */
    extLinkId?: string;
    /** 
     * お客さま需要家区分：半角英数混在
     */
    visitDmdiv?: string;
    /** 
     * お客さま需要家区分名称：全角半角混在
     */
    visitDmdivAname?: string;
    /** 
     * 住所コード：半角英数混在
     */
    addressCode?: string;
    /** 
     * 郵便番号：半角数字
     */
    postno?: string;
    /** 
     * 都道府県名称：全角文字
     */
    pfcAname?: string;
    /** 
     * 市区郡町村名称：全角文字
     */
    mptAname?: string;
    /** 
     * 町域名称：全角文字
     */
    townAreaName?: string;
    /** 
     * 大字丁目名称：全角文字
     */
    ooazaName?: string;
    /** 
     * お客さま住所番地・号・分筆号：全角文字
     */
    visitAddrBlockgoulot?: string;
    /** 
     * お客さま住所番地・号・分筆号（カナ）：全角英数カナ
     */
    visitAddrBlockgoulotkana?: string;
    /** 
     * 住宅・棟号漢字名：全角文字
     */
    visitSupadrAname?: string;
    /** 
     * 住宅・棟号カナ名：全角文字
     */
    visitSupadrKananm?: string;
    /** 
     * 屋号・業種漢字名：全角文字
     */
    visitYagouAname?: string;
    /** 
     * 屋号・業種カナ名：全角文字
     */
    visitYagouKananm?: string;
    /** 
     * 表示住所漢字：全角文字
     */
    empposAddrAnameF?: string;
}
